import dayjs from "dayjs";
import { PolicyDetailsEnum, } from "./itinerary";
export var GetExerciseEligibilitiesRequestV1Enum;
(function (GetExerciseEligibilitiesRequestV1Enum) {
    GetExerciseEligibilitiesRequestV1Enum["ByItineraryIds"] = "ByItineraryIds";
})(GetExerciseEligibilitiesRequestV1Enum || (GetExerciseEligibilitiesRequestV1Enum = {}));
export var ExerciseEligibilityV1Enum;
(function (ExerciseEligibilityV1Enum) {
    ExerciseEligibilityV1Enum["IsEligible"] = "IsEligible";
    ExerciseEligibilityV1Enum["NotEligible"] = "NotEligible";
})(ExerciseEligibilityV1Enum || (ExerciseEligibilityV1Enum = {}));
export var EligibilitySliceEnum;
(function (EligibilitySliceEnum) {
    EligibilitySliceEnum["IsEligible"] = "IsEligible";
    EligibilitySliceEnum["NotEligible"] = "NotEligible";
})(EligibilitySliceEnum || (EligibilitySliceEnum = {}));
export var EligibilitySegmentEnum;
(function (EligibilitySegmentEnum) {
    EligibilitySegmentEnum["IsEligible"] = "IsEligible";
    EligibilitySegmentEnum["NotEligible"] = "NotEligible";
})(EligibilitySegmentEnum || (EligibilitySegmentEnum = {}));
export var FlightDisruptionEnum;
(function (FlightDisruptionEnum) {
    FlightDisruptionEnum["NotDisrupted"] = "NotDisrupted";
    FlightDisruptionEnum["IsDisrupted"] = "IsDisrupted";
})(FlightDisruptionEnum || (FlightDisruptionEnum = {}));
export var FlightDisruptionReasonEnum;
(function (FlightDisruptionReasonEnum) {
    FlightDisruptionReasonEnum["Delayed"] = "Delayed";
    FlightDisruptionReasonEnum["MissedConnection"] = "MissedConnection";
    FlightDisruptionReasonEnum["AirlineCancellation"] = "AirlineCancellation";
})(FlightDisruptionReasonEnum || (FlightDisruptionReasonEnum = {}));
export var FlightStatusResultEnum;
(function (FlightStatusResultEnum) {
    FlightStatusResultEnum["IsFound"] = "IsFound";
    FlightStatusResultEnum["NotFound"] = "NotFound";
})(FlightStatusResultEnum || (FlightStatusResultEnum = {}));
export var GetDisruptionRefundResponseEnum;
(function (GetDisruptionRefundResponseEnum) {
    GetDisruptionRefundResponseEnum["Success"] = "Success";
    GetDisruptionRefundResponseEnum["NoDisruptionProtectionAttached"] = "NoDisruptionProtectionAttached";
    GetDisruptionRefundResponseEnum["NoDisruptionDetected"] = "NoDisruptionDetected";
})(GetDisruptionRefundResponseEnum || (GetDisruptionRefundResponseEnum = {}));
export var SubmitDisruptionRefundResponseEnum;
(function (SubmitDisruptionRefundResponseEnum) {
    SubmitDisruptionRefundResponseEnum["Success"] = "Success";
    SubmitDisruptionRefundResponseEnum["Failure"] = "Failure";
})(SubmitDisruptionRefundResponseEnum || (SubmitDisruptionRefundResponseEnum = {}));
export var DisruptionFlightRefundResult;
(function (DisruptionFlightRefundResult) {
    DisruptionFlightRefundResult["Success"] = "Success";
    DisruptionFlightRefundResult["Failure"] = "Failure";
})(DisruptionFlightRefundResult || (DisruptionFlightRefundResult = {}));
export var getEligibleSliceFromEligibility = function (eligibility) {
    var eligibleSliceIndex = eligibility.slices.findIndex(function (slice) {
        switch (slice.EligibilitySlice) {
            case EligibilitySliceEnum.IsEligible:
                return true;
            case EligibilitySliceEnum.NotEligible:
            default:
                return false;
        }
    });
    if (eligibleSliceIndex === 0 || eligibleSliceIndex === 1) {
        return {
            // note: there is no need to add any safeguard here since the index is returned through findIndex
            slice: eligibility.slices[eligibleSliceIndex],
            index: eligibleSliceIndex,
        };
    }
    return undefined;
};
export var getDisruptionProductTypeFromAncillaries = function (ancillaries) {
    if (ancillaries) {
        var delay = ancillaries.delay, missedConnection = ancillaries.missedConnection;
        return !!delay
            ? "delays"
            : !!missedConnection
                ? "missed_connections"
                : undefined;
    }
    return undefined;
};
export var getCoverageAndPremiumFromDisruptionAncillaries = function (ancillaries) {
    var _a, _b;
    var delayPolicyDetails = (_a = ancillaries.delay) === null || _a === void 0 ? void 0 : _a.policyDetails;
    var delayCoverageAndPremium = delayPolicyDetails
        ? {
            coverage: delayPolicyDetails.coverage,
            premium: delayPolicyDetails.premium,
        }
        : undefined;
    var missedConnectionPolicyDetails = (_b = ancillaries.missedConnection) === null || _b === void 0 ? void 0 : _b.policyDetails;
    var missedConnectionCoverageAndPremium = (function () {
        switch (missedConnectionPolicyDetails === null || missedConnectionPolicyDetails === void 0 ? void 0 : missedConnectionPolicyDetails.PolicyDetails) {
            case PolicyDetailsEnum.FixedPolicyDetails:
                return {
                    coverage: missedConnectionPolicyDetails.coverage,
                    premium: missedConnectionPolicyDetails.premium,
                };
            /*
              note: the percentage model is not used in our BE workflow; in case we do receive a percentage response,
              this will make it return undefined rather than potentially displaying an incorrect value
            */
            case PolicyDetailsEnum.PercentagePolicyDetails:
            default:
                return undefined;
        }
    })();
    return delayCoverageAndPremium !== null && delayCoverageAndPremium !== void 0 ? delayCoverageAndPremium : missedConnectionCoverageAndPremium;
};
/*
  note: this helper is used to check weither it has passed the time window for rebooking the departure flight.
  This logic is currently relevant only in the agent portal workflow.
*/
export var hasPassedTheTimeWindowToRebookTheDepartureFlight = function (lastDepartureSegment) {
    var _a;
    return dayjs().isAfter(
    /*
      note: The agent should be able to rebook the outbound flight until 24 hours after the scheduled arrival time
      and then it should switch to the return flight; see https://hopper-jira.atlassian.net/browse/BF-1270
    */
    dayjs((_a = lastDepartureSegment.zonedScheduledArrival) !== null && _a !== void 0 ? _a : lastDepartureSegment.scheduledArrival).add(24, "hours"));
};
export var getIsSelectingReturnFlightForRebook = function (_a) {
    var eligibility = _a.eligibility, departureSlice = _a.departureSlice, returnSlice = _a.returnSlice;
    var eligibleSliceIndex = eligibility === null || eligibility === void 0 ? void 0 : eligibility.slices.findIndex(function (slice) { return slice.EligibilitySlice === EligibilitySliceEnum.IsEligible; });
    var firstReturnSegment = returnSlice === null || returnSlice === void 0 ? void 0 : returnSlice.segments[0];
    var lastDepartureSegment = departureSlice === null || departureSlice === void 0 ? void 0 : departureSlice.segments[departureSlice.segments.length - 1];
    if (eligibleSliceIndex === 0) {
        return false;
    }
    else if (eligibleSliceIndex === 1) {
        return true;
    }
    else {
        // We should only get here if we are in agent portal.
        // Even if there's no eligible slice, we still want agents to be able to exercise DP.
        // We display "return" in the flow if return flight exists and certain amount of time
        // has passed since departure flight.
        return (!!firstReturnSegment &&
            !!lastDepartureSegment &&
            hasPassedTheTimeWindowToRebookTheDepartureFlight(lastDepartureSegment));
    }
};
//# sourceMappingURL=flightDisruption.js.map